module.exports = __webpack_public_path__ + "static/media/460JamesPBrawleyDrNW_2018-06-12_169.96351f43.jpg";